import { Box } from "@mui/material";
import { useSelectable } from "../../../utils/use-selectable";

import type { ElementFormatType, NodeKey } from "lexical";
import type { FC } from "react";

export const PollWrapper: FC<{
  nodeKey: NodeKey;
  format?: ElementFormatType;
  children?: React.ReactNode;
}> = ({ nodeKey, children }) => {
  const selected = useSelectable(nodeKey);

  return (
    <Box
      sx={{
        width: "100%",
        p: 1,
        borderRadius: 1,
        outlineWidth: selected ? 2 : 1,
        outlineColor: "primary.main",
        outlineStyle: selected ? "solid" : "dotted",
      }}
    >
      {children}
    </Box>
  );
};
